import React, { useMemo, useState, useEffect } from "react";
import styles from "./style.module.scss";
import { useSelector } from "react-redux";
import { RootState } from "../../../state";
import { isEqual } from "lodash";

const HEADERS = [
  { key: "totalInterventionTime", label: "Σ Cautions", width: 80 },
  { key: "timeToNextExtension", label: "+Lap In", width: 80 },
  { key: "addedLaps", label: "+Laps", width: 60 },
] as const;

export default function InterventionsTable() {
  const [tick, setTick] = useState(0);

  const interventionsData = useSelector(
    (state: RootState) => state.interventions,
    isEqual,
  );

  const strategyImport = useSelector(
    (state: RootState) => state.imports.imports.strategy,
    isEqual,
  );

  // Update every 100ms for live countdown
  useEffect(() => {
    const interval = setInterval(() => setTick((t) => t + 1), 100);
    return () => clearInterval(interval);
  }, []);

  const { totalInterventionTime, timeToNextExtension } = useMemo(() => {
    const currentTime = Date.now();
    let totalInterventionTime = 0;
    const flagPeriods = interventionsData.flagPeriods ?? [];
    const cutoffTime = interventionsData.cutoffTime ?? Infinity;

    for (const flagPeriod of flagPeriods) {
      if (!["FULL_YELLOW", "SAFETY_CAR"].includes(flagPeriod.type)) {
        continue;
      }
      const startTime = flagPeriod.startTime;
      let endTime = flagPeriod.endTime ?? currentTime;
      if (startTime >= cutoffTime) continue;
      endTime = Math.min(endTime, cutoffTime);
      totalInterventionTime += endTime - startTime;
    }

    const addedLaps = interventionsData.addedLaps ?? 0;
    const tRef = (strategyImport?.data?.tRefForIntervention ?? 0) * 1000;
    const timeToNextExtension =
      tRef > 0 ? (addedLaps + 1) * tRef - totalInterventionTime : 0;

    return { totalInterventionTime, timeToNextExtension };
  }, [interventionsData, strategyImport, tick]);

  return (
    <div className={styles.container}>
      <table>
        <colgroup>
          {HEADERS.map((header) => (
            <col key={header.key} style={{ width: `${header.width}px` }} />
          ))}
        </colgroup>
        <thead>
          <tr>
            {HEADERS.map((header) => (
              <th key={header.key}>{header.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{(totalInterventionTime / 1000).toFixed(3)}</td>
            <td>{(timeToNextExtension / 1000).toFixed(3)}</td>
            <td>{interventionsData.addedLaps ?? 0}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
